import React, { useEffect, useState } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import api from '../api/api';
import { ShowIfLoggedIn, ShowIfLoggedInAndVerified } from '../features/auth/auth_utils';
import './Sidebar.css';

export default function Sidebar({filters, onChange}) {
  const [fundHouses, setFundHouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [Method1, setMethod1] = useState(false);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.get('/fund-houses')
    ]).then(([funds]) => {
      setFundHouses(funds.data);
    }).catch(err => setError('Failed to load fund houses.')
    ).finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner animation="border" className="m-3" />;

  const handleMultiSelect = (type, value) => {
    if (Method1) {
      const current = new Set(filters[type]);
      if (current.has(value)) current.delete(value);
      else current.add(value);
      console.log("Updated value in sidebar.js 1: ", value);
      const newFilter = { ...filters, [type]: Array.from(current) }
      console.log("Updated value in sidebar.js 2: ", newFilter);
      onChange(newFilter);
    } else {
      console.log("For Change of value in sidebar.js 1: ", type, value);
      onChange(type, value);
    }

  };

  function capitalizeWords(str) {
    if (!str) return ''; // Handle empty or null strings

    return str
      .split(' ') // Split the string into an array of words
      .map(word => {
        if (word.length === 0) return ''; // Handle empty words
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // Capitalize first letter, lowercase rest
      })
      .join(' '); // Join the words back into a string
  }

  const renderOptionsHeading = (type) => (
      <strong>{capitalizeWords(type.replace(/([A-Z])/g, ' $1'))}</strong>
  );

  const renderOptions = (type, options) => (
    <div>
      <div>
        {options.map(option => (
          <Form.Check
            key={option.fund_info_id}
            type="checkbox"
            label={option.fund_name}
            checked={filters[type]?.includes(option.fund_info_id)}
            onChange={() => handleMultiSelect(type, option.fund_info_id)}
            className="ms-2 custom-checkbox"
          />
        ))}
      </div>
    </div>
  );

  function RenderOptions2(props) {
      const dynamicStyle = {
        overflow: 'scroll'
      }
      const type = props.type;
      const options = props.options;

      return (
        <div className="mb-2">
          <strong>{capitalizeWords(type.replace(/([A-Z])/g, ' $1'))}</strong>
          <div style={dynamicStyle}>
            {options.map(option => (
              <Form.Check
                key={option.fund_info_id}
                type="checkbox"
                label={option.fund_name}
                checked={filters[type]?.includes(option.fund_info_id)}
                onChange={() => handleMultiSelect(type, option.fund_info_id)}
                className="ms-2"
              />
            ))}
          </div>
        </div>
      );
    }

  return (
    <div className="sidebar bg-light p-3">
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <>
           <ShowIfLoggedInAndVerified>
              <div  className="sidebar-part-top">
                  <div style={{background: '#f8f9fa', height: '95%'}}>
                      {renderOptionsHeading('fundHouses') }
                      <div style={{overflow: 'auto', height: '95%'}} > 
                          <Form className="p-1">
                              {renderOptions('fundHouses', fundHouses)}
                          </Form>
                      </div>

                  </div>
              </div>
            </ShowIfLoggedInAndVerified>
            <div className="sidebar-part-bottom">
                <h6 className="text-muted flex-column my-1 fw-bold">Note</h6>
                <div style={{ height: '90%', overflow: 'auto' }} className="sidebar-note" >
                    <p>
                      <strong>Risks in Mutual Fund -</strong> https://www.amfiindia.com/investor/knowledge-center-info?zoneName=riskInMutualFunds
                    </p>
                    <p>
                      <strong>Types of Mutual Funds -</strong> https://www.amfiindia.com/investor/knowledge-center-info?zoneName=typesOfMutualFunds
                    </p>
                    <p>
                      <strong>Categorization of Mutual Fund Schemes -</strong> https://www.amfiindia.com/investor/knowledge-center-info?zoneName=CategorizationOfMutualFundSchemes
                    </p>
                </div>
            </div>
          </>
        )}
    </div>
  );
}

